import HttpError from 'ra-core/lib/util/HttpError';
import fetchJsonLd from '@api-platform/api-doc-parser/lib/hydra/fetchJsonLd';
import {getDocumentationUrlFromHeaders} from '@api-platform/api-doc-parser/lib/hydra/parseHydraDocumentation';
import {promises} from 'jsonld';
import jwt from 'jsonwebtoken';
import refreshToken from './security/refreshToken';

const baseFetchHydra =  (url, options = {}) => {
    const requestHeaders = options.headers || new Headers();

    if (options.user && options.user.authenticated && options.user.token) {
        requestHeaders.set('Authorization', options.user.token);
    }

    return fetchJsonLd(url, {
        ...options,
        headers: requestHeaders,
    }).then(data => {
        const status = data.response.status;

        if (status < 200 || status >= 300) {
            return promises
                .expand(data.body, {
                    base: getDocumentationUrlFromHeaders(data.response.headers),
                })
                .then(json => {
                   let errors = {};
                    for (let error of json[0]['http://localhost:8080/docs.jsonld#violations']) {
                        errors[error['http://localhost:8080/docs.jsonld#propertyPath'][0]['@value']] = error['http://localhost:8080/docs.jsonld#message'][0]['@value'];
                    }

                    let errorMessage = options.method === 'PUT' ||options.method === 'POST'? 'ra.message.invalid_form' : json['0']['http://www.w3.org/ns/hydra/core#title']['0']['@value'];

                    return Promise.reject(
                          new HttpError(
                              errorMessage,
                              status,
                              errors
                          ),
                      );
                })
                .catch(e => {
                    if (e.hasOwnProperty('body')) {
                      return Promise.reject(e);
                    }
                    return Promise.reject(
                        new HttpError(e.message, status),
                    );
                });
        }
        return {
            status: status,
            headers: data.response.headers,
            json: data.body,
        };
    });
};


const fetchHydraRetry = async (url, options, n = 2) => {
    let decodedToken = jwt.decode(localStorage.getItem('token'));
    if (!decodedToken || decodedToken.exp < (Math.floor(Date.now() / 1000))) {
        await refreshToken();
    }
    const fetchHeaders = {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Admin-Request': 'true',
        'Accept-Language': localStorage.getItem('language')
    };

    options = {
        ...options,
        headers: new Headers(fetchHeaders),
    };

    try {
        return await baseFetchHydra(url, options)
    } catch(err) {
        if(err.status === 401 && n > 1) {
            await refreshToken();
            return await fetchHydraRetry(url, options, n - 1);
        }
        throw err;
    }
};
export default (url, options = {}) => {
    return fetchHydraRetry(url, options);
}



// WEBPACK FOOTER //
// ./src/fetchHydra.js